const Footer = () => {
	return (
		<footer className="bg-slate-900 text-gray-500 text-center h-[60px] flex items-center justify-center">
			&copy; 2025 ICEPyramid Communication Limited | All Rights Reserved.
		</footer>
	);
};

export default Footer;
